import { lazy, Suspense } from "react";
import { withMainLayout } from "@shared/layouts/withMainLayout";
import { RadarLayout } from "@features/Radar/layouts/RadarLayout";
import { RadarPageContentSkeleton } from "@modules/radar/shared/components/RadarPageContent/RadarPageContentSkeleton";

const RadarPageContent = lazy(() =>
  import(
    "@modules/radar/shared/components/RadarPageContent/RadarPageContent"
  ).then((module) => ({
    default: module.RadarPageContent,
  })),
);

function RadarPageContentWithSuspense() {
  return (
    <RadarLayout>
      <Suspense fallback={<RadarPageContentSkeleton />}>
        <RadarPageContent />
      </Suspense>
    </RadarLayout>
  );
}

export const RadarPage = withMainLayout(RadarPageContentWithSuspense);
